module.exports = __webpack_public_path__ + "img/Header-title-1-SVG.312fed65.svg";